/* istanbul ignore file */
export const globalConfig =
  (typeof self === 'object' && self.self === self && self) ||
  (typeof global === 'object' && global.global === global && global) ||
  this ||
  {};
export const document = globalConfig.document || {};
